import type { ApiJobSynonymId } from '#/api/types/ApiTypedId';
import type { EstimatedRange } from '#/modules/salary/types/EstimatedRange';

type CareerPathAddTitleAlgoliaHit = {
  objectID: string;
  jobTitle?: { id?: string; name: string };
};

const normalizeJobTitleName = (value: string) => value.trim().toLowerCase();

export function filterCareerPathAddTitleHits<
  T extends CareerPathAddTitleAlgoliaHit,
>(args: {
  hits: T[];
  careerPathData: EstimatedRange[];
  selectedSynonymId: ApiJobSynonymId;
}): T[] {
  const excludedSynonymIds = new Set([
    args.selectedSynonymId,
    ...args.careerPathData.map((careerPath) => careerPath.synonymId),
  ]);

  const excludedJobTitleIds = new Set(
    args.careerPathData.map((careerPath) => careerPath.jobTitleId),
  );

  const excludedJobTitleNames = new Set(
    args.careerPathData
      .map((careerPath) => normalizeJobTitleName(careerPath.jobTitleName))
      .filter(Boolean),
  );

  return args.hits
    .filter((hit) => !excludedSynonymIds.has(hit.objectID))
    .filter((hit) => {
      const jobTitleId = hit.jobTitle?.id;
      if (jobTitleId && excludedJobTitleIds.has(jobTitleId)) return false;

      const jobTitleName = hit.jobTitle?.name;
      if (
        jobTitleName &&
        excludedJobTitleNames.has(normalizeJobTitleName(jobTitleName))
      )
        return false;

      return true;
    });
}
